import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { BookLibrarySearchPage } from 'teacher-ui-client/components/page/book-library/search'
import type BookLibrarySearchRoute from 'teacher-ui-client/subscription-type/book-library/search/route'

interface Signature {
  Args: {
    model: ModelFor<BookLibrarySearchRoute>
  }
}
export const SubscriptionTypeBookLibrarySearchPage: TOC<Signature> = <template>
  <BookLibrarySearchPage
    @loadCollections={{@model.loadCollections}}
    @loadPrimaryFilters={{@model.loadPrimaryFilters}}
  />
  {{outlet}}
</template>

export default RouteTemplate(SubscriptionTypeBookLibrarySearchPage)
